module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Light.905d0b257c845720b6fa7f0a7fa75b9e.woff2";